import { AccountingPlatform } from '../accounting';

export enum CrmPlatform {
  SALESFORCE = 'Salesforce',
  HUBSPOT = 'HubSpot',
}

export enum PaymentPlatform {
  STRIPE = 'STRIPE',
  AIRWALLEX = 'AIRWALLEX',
}

export enum ExternalPlatform {
  EXTERNAL_PLATFORM = 'EXTERNAL_PLATFORM',
}

export enum MeteringPlatform {
  STIGG = 'STIGG',
}

export type IntegrationPlatform = CrmPlatform | AccountingPlatform | PaymentPlatform | ExternalPlatform | MeteringPlatform;

export const IntegrationPlatform = { ...CrmPlatform, ...AccountingPlatform, ...PaymentPlatform, ...ExternalPlatform, ...MeteringPlatform };
